import VuetifyMask from 'vuetify-mask';

export default defineNuxtPlugin({
  name: 'vuetify-mask',
  setup(nuxtApp) {
    nuxtApp.vueApp.use(VuetifyMask);
  },
});
